import { datadogLogs } from '@datadog/browser-logs'

import type { ExpressPaymentType } from './types'

export function errorBoundaryLogger(paymentType: ExpressPaymentType) {
  datadogLogs.logger.error(`ExpressCheckout: Unexpected error thrown by ${paymentType}`)
}
